import request from './build'


export const signIn = ((params) => {
    return request({
        url: '/oms/login',
        data: params,
        method: 'POST'
    });
});

export const capTcha = (() => {
    return request({
        url: '/oms/puw/getImgCode',
        method: 'GET'
    });
});

export const checkImgCode = ((params) => {
    return request({
        url: '/oms/puw/checkImgCode',
        data: params,
        method: 'POST'
    });
});

export const checkNext = ((params) => {
    return request({
        url: '/oms/puw/checkNext',
        data: params,
        method: 'POST'
    });
});

export const updatePassWord = ((params) => {
    return request({
        url: '/oms/puw/updatePassWord',
        data: params,
        method: 'POST'
    });
});

export const signOut = (() => {
    return request({
        url: '/oms/logout',
        method: 'GET'
    });
});

export const getOnlineUserInfo = (() => {
    return request({
        url: '/oms/mgr/onlineUser',
        method: 'GET'
    });
});

export const toUserInfo = ((userId) => {
    return request({
        url: '/oms/mgr/toUserInfo/' + userId,
        method: 'GET'
    });
});

export const isOnline = (() => {
    return request({
        url: '/oms/mgr/online',
        method: 'GET'
    });
});

export const getRoleMenu = (() => {
    return request({
        url: '/oms/roleMenu',
        method: 'GET'
    });
});

export const getChildRoleMenu = ((params) => {
    return request({
        url: '/oms/childRoleMenu',
        data: params,
        method: 'post'
    });
});



export const getUserManageList = ((params) => {
    return request({
        url: '/oms/mgr/list',
        data: params,
        method: 'POST'
    });
});

export const addUser = ((params) => {
    return request({
        url: '/oms/mgr/add',
        data: params,
        method: 'POST'
    });
});

export const editUser = ((params) => {
    return request({
        url: '/oms/mgr/edit',
        data: params,
        method: 'POST'
    });
});

export const deleteUser = ((params) => {
    return request({
        url: '/oms/mgr/delete',
        data: params,
        method: 'POST'
    });
});

export const resetPassword = ((params) => {
    return request({
        url: '/oms/mgr/reset',
        data: params,
        method: 'POST'
    });
});

export const changeUserPwd = ((params) => {
    return request({
        url: '/oms/mgr/changePwd',
        data: params,
        method: 'POST'
    });
});

export const freezeUser = ((params) => {
    return request({
        url: '/oms/mgr/freeze',
        data: params,
        method: 'POST'
    });
});

export const unfreezeUser = ((params) => {
    return request({
        url: '/oms/mgr/unfreeze',
        data: params,
        method: 'POST'
    });
});

export const getDeptTree = ((params) => {
    return request({
        url: '/oms/dept/tree',
        data: params,
        method: 'POST'
    });
});

export const addDept = ((params) => {
    return request({
        url: '/oms/dept/add',
        data: params,
        method: 'POST'
    });
});

export const updateDept = ((params) => {
    return request({
        url: '/oms/dept/update',
        data: params,
        method: 'POST'
    });
});

export const delDept = ((params) => {
    return request({
        url: '/oms/dept/delete',
        data: params,
        method: 'POST'
    });
});


export const getRoleList = ((params) => {
    return request({
        url: '/oms/role/list',
        data: params,
        method: 'POST'
    });
});

export const addRole = ((params) => {
    return request({
        url: '/oms/role/add',
        data: params,
        method: 'POST'
    });
});

export const setRoleAuthority = ((params) => {
    return request({
        url: '/oms/role/setAuthority',
        data: params,
        method: 'POST'
    });
});


export const editRole = ((params) => {
    return request({
        url: '/oms/role/edit',
        data: params,
        method: 'POST'
    });
});

export const delRole = ((params) => {
    return request({
        url: '/oms/role/remove',
        data: params,
        method: 'POST'
    });
});

export const getDictList = ((params) => {
    return request({
        url: '/oms/dict/list',
        data: params,
        method: 'POST'
    });
});

export const addDict = ((params) => {
    return request({
        url: '/oms/dict/add',
        data: params,
        method: 'POST'
    });
});

export const editDict = ((params) => {
    return request({
        url: '/oms/dict/update',
        data: params,
        method: 'POST'
    });
});

export const delDict = ((params) => {
    return request({
        url: '/oms/dict/delete',
        data: params,
        method: 'POST'
    });
});

export const getMenuList = ((params) => {
    return request({
        url: '/oms/menu/list',
        data: params,
        method: 'POST'
    });
});

export const addMenu = ((params) => {
    return request({
        url: '/oms/menu/add',
        data: params,
        method: 'POST'
    });
});

export const editMenu = ((params) => {
    return request({
        url: '/oms/menu/edit',
        data: params,
        method: 'POST'
    });
});

export const delMenu = ((params) => {
    return request({
        url: '/oms/menu/remove',
        data: params,
        method: 'POST'
    });
});

export const menuTreeListByRoleId = ((roleId) => {
    return request({
        url: '/oms/menu/menuTreeListByRoleId/' + roleId,
        method: 'GET'
    });
});

export const getLoginLogList = ((params) => {
    return request({
        url: '/oms/loginLog/list',
        data: params,
        method: 'POST'
    });
});

export const emptyLoginLog = (() => {
    return request({
        url: '/oms/loginLog/delLoginLog',
        method: 'POST'
    });
});


export const getOperationLogList = ((params) => {
    return request({
        url: '/oms/log/list',
        data: params,
        method: 'POST'
    });
});

export const emptyOperationLog = (() => {
    return request({
        url: '/oms/log/delLog',
        method: 'POST'
    });
});

export const operationLogDetail = ((params) => {
    return request({
        url: '/oms/log/detail',
        data: params,
        method: 'POST'
    });
});

export const noticeList = ((params) => {
    return request({
        url: '/oms/notice/list',
        data: params,
        method: 'POST'
    });
});

export const addNotice = ((params) => {
    return request({
        url: '/oms/notice/add',
        data: params,
        method: 'POST'
    });
});

export const delNotice = ((params) => {
    return request({
        url: '/oms/notice/delete',
        data: params,
        method: 'POST'
    });
});

export const editNotice = ((params) => {
    return request({
        url: '/oms/notice/update',
        data: params,
        method: 'POST'
    });
});

export const dataPermissionList = ((params) => {
    return request({
        url: '/oms/dataPermissionGroup/list',
        data: params,
        method: 'POST'
    });
});

export const addDataPermission = ((params) => {
    return request({
        url: '/oms/dataPermissionGroup/add',
        data: params,
        method: 'POST'
    });
});

export const updateDataPermission = ((params) => {
    return request({
        url: '/oms/dataPermissionGroup/update',
        data: params,
        method: 'POST'
    });
});


export const delDataPermission = ((params) => {
    return request({
        url: '/oms/dataPermissionGroup/delete',
        data: params,
        method: 'POST'
    });
});

export const dataPermissionRuleList = ((params) => {
    return request({
        url: '/oms/dataPermissionGroup/ruleList',
        data: params,
        method: 'POST'
    });
});

export const addDataPermissionRule = ((params) => {
    return request({
        url: '/oms/dataPermissionGroup/addRule',
        data: params,
        method: 'POST'
    });
});

export const delDataPermissionRule = ((params) => {
    return request({
        url: '/oms/dataPermissionGroup/deleteRule',
        data: params,
        method: 'POST'
    });
});

export const dataPermissionGroupType = ((params) => {
    return request({
        url: '/oms/dataPermissionGroup/dataPermissionGroupType',
        data: params,
        method: 'POST'
    });
});

export const chooseDataPermissionRule = ((params) => {
    return request({
        url: '/oms/dataPermissionGroup/chooseRule/' + params.type,
        data: params,
        method: 'GET'
    });
});

export const dataPermissionGroupNameList = ((params) => {
    return request({
        url: '/oms/dataPermissionGroup/groupNameList',
        data: params,
        method: 'POST'
    });
});

export const dataPermissionBindingGroup = ((params) => {
    return request({
        url: '/oms/dataPermissionGroup/bindingGroup',
        data: params,
        method: 'POST'
    });
});

export const jobList = ((params) => {
    return request({
        url: '/oms/job/list',
        data: params,
        method: 'POST'
    });
});

export const addJob = ((params) => {
    return request({
        url: '/oms/quartz/add/task',
        data: params,
        method: 'POST'
    });
});

export const freezeJob = ((params) => {
    return request({
        url: '/oms/quartz/list/optionjob',
        data: params,
        method: 'POST'
    });
});

export const nowJob = ((params) => {
    return request({
        url: '/oms/quartz/runtask/rightnow',
        data: params,
        method: 'POST'
    });
});



export const editJob = ((params) => {
    return request({
        url: '/oms/quartz/edit/task',
        data: params,
        method: 'POST'
    });
});


export const deleteJob = ((params) => {
    return request({
        url: '/oms/job/deleteJob',
        data: params,
        method: 'POST'
    });
});

export const recordsList = ((params) => {
    return request({
        url: '/oms/quar/recordList',
        data: params,
        method: 'POST'
    });
});

export const pauseJob = ((params) => {
    return request({
        url: '/oms/job/pauseJob',
        data: params,
        method: 'POST'
    });
});

export const resumeJob = ((params) => {
    return request({
        url: '/oms/job/resumeJob',
        data: params,
        method: 'POST'
    });
});

export const exportFilePageList = ((params) => {
    return request({
        url: '/oms/tempSoDownload/list',
        data: params,
        method: 'POST'
    });
});

export const deleteExportFileByCodes = ((params) => {
    return request({
        url: '/oms/tempSoDownload/delete',
        data: params,
        method: 'POST'
    });
});

export const validateExportFile = ((params) => {
    return request({
        url: '/oms/tempSoDownload/downloadValidate',
        data: params,
        method: 'POST'
    });
});

export const reportExportFile = ((params) => {
    return request({
        url: '/oms/report/downloadReportFile',
        data: params,
        method: 'POST'
    });
});


export const reportFormsList = ((params) => {
    return request({
        url: '/oms/report/reportList',
        data: params,
        method: 'POST'
    });
});

export const deleteReportForms = ((params) => {
    return request({
        url: '/oms/report/deleteReportForm',
        data: params,
        method: 'POST'
    });
});


export const reportOrderSearchList = ((params) => {
    return request({
        url: '/oms/report/reportOrderSearchList',
        data: params,
        method: 'POST'
    });
});


export const mdLogisticsCompanyList = ((params) => {
    return request({
        url: '/oms/mdLogisticsCompany/list',
        data: params,
        method: 'POST'
    });
});

export const addMdLogisticsCompany = ((params) => {
    return request({
        url: '/oms/mdLogisticsCompany/add',
        data: params,
        method: 'POST'
    });
});

export const editMdLogisticsCompany = ((params) => {
    return request({
        url: '/oms/mdLogisticsCompany/update',
        data: params,
        method: 'POST'
    });
});

export const delMdLogisticsCompany = ((params) => {
    return request({
        url: '/oms/mdLogisticsCompany/delete',
        data: params,
        method: 'POST'
    });
});

export const shopList = ((params) => {
    return request({
        url: '/oms/shop/list',
        data: params,
        method: 'POST'
    });
});

export const manuList = ((params) => {
    return request({
        url: '/oms/manufacturer/list',
        data: params,
        method: 'POST'
    });
});



export const initShop = (() => {
    return request({
        url: '/oms/shop/init',
        method: 'GET'
    });
});

export const initShopLogic = (() => {
    return request({
        url: '/oms/shopLogic/init',
        method: 'GET'
    });
});



export const getShopById = ((id) => {
    return request({
        url: '/oms/shop/find/' + id,
        method: 'GET'
    });
});

export const getShopByPlamId = ((id) => {
    return request({
        url: '/oms/shop/plamId/' + id,
        method: 'GET'
    });
});

export const addShop = ((params) => {
    return request({
        url: '/oms/shop/add',
        data: params,
        method: 'POST'
    });
});

export const addShopLogic = ((params) => {
    return request({
        url: '/oms/shopLogic/add',
        data: params,
        method: 'POST'
    });
});

export const updateShopLogicDefault = ((id) => {
    return request({
        url: '/oms/shopLogic/update/'+id,
       
        method: 'GET'
    });
});


export const updateShop = ((params) => {
    return request({
        url: '/oms/shop/update',
        data: params,
        method: 'POST'
    });
});
export const warehouseList = ((params) => {
    return request({
        url: '/oms/bWarehouse/list',
        data: params,
        method: 'POST'
    });
});

export const warehouseLog = ((params) => {
    return request({
        url: '/oms/bWarehouse/log',
        data: params,
        method: 'POST'
    });
});

export const addWarehouse = ((params) => {
    return request({
        url: '/oms/bWarehouse/add',
        data: params,
        method: 'POST'
    });
});

export const updateWarehouse = ((params) => {
    return request({
        url: '/oms/bWarehouse/update',
        data: params,
        method: 'POST'
    });
});


export const freezeWarehouse = ((params) => {
    return request({
        url: '/oms/bWarehouse/freeze',
        data: params,
        method: 'POST'
    });
});

export const unfreezeWarehouse = ((params) => {
    return request({
        url: '/oms/bWarehouse/unfreeze',
        data: params,
        method: 'POST'
    });
});

export const deleteWarehouse = ((params) => {
    return request({
        url: '/oms/bWarehouse/delete',
        data: params,
        method: 'POST'
    });
});


export const getAreas = (() => {
    return request({
        url: '/oms/bWarehouse/getArea',
        method: 'GET'
    });
});


export const getAreaByPid = ((pid) => {
    return request({
        url: '/oms/bWarehouse/area/' + pid,
        method: 'GET'
    });
});

export const shopLogicCarry = ((params) => {
    return request({
        url: '/oms/shopLogic/carry/',
        data: params,
        method: 'POST'
    });
});


export const getAreaByPidNew = ((pid) => {
    return request({
        url: '/oms/mdRegion/area/' + pid,
        method: 'GET'
    });
});

export const findWarehouseById = ((id) => {
    return request({
        url: '/oms/bWarehouse/find/' + id,
        method: 'GET'
    });
});

export const salesAccountList = ((params) => {
    return request({
        url: '/oms/report/salesAccount/list',
        data: params,
        method: 'POST'
    });
});

export const salesAccountInit = ((params) => {
    return request({
        url: '/oms/report/salesAccount/init',
        data: params,
        method: 'POST'
    });
});

export const salesAccountDownloadExport = ((params) => {
    return request({
        url: '/oms/report/salesAccount/exportPlarformOrder',
        data: params,
        method: 'POST'
    });
});

export const taxBalanceList = ((params) => {
    return request({
        url: '/oms/report/taxBalance/list',
        data: params,
        method: 'POST'
    });
});

export const balanceReportList = ((params) => {
    return request({
        url: '/oms/report/balanceReportList',
        data: params,
        method: 'POST'
    });
});

export const taxBalanceInit = ((params) => {
    return request({
        url: '/oms/report/taxBalance/init',
        data: params,
        method: 'POST'
    });
});

export const taxBalanceDownloadExport = ((params) => {
    return request({
        url: '/oms/report/taxBalance/exportPlarformOrder',
        data: params,
        method: 'POST'
    });
});

export const taxStatementList = ((params) => {
    return request({
        url: '/oms/report/taxStatement/list',
        data: params,
        method: 'POST'
    });
});

export const taxStatementInit = ((params) => {
    return request({
        url: '/oms/report/taxStatement/init',
        data: params,
        method: 'POST'
    });
});

export const taxStatementDownloadExport = ((params) => {
    return request({
        url: '/oms/report/taxStatement/exportPlarformOrder',
        data: params,
        method: 'POST'
    });
});


export const warehouseStockList = ((params) => {
    return request({
        url: '/oms/pmWarehouseStock/list',
        data: params,
        method: 'POST'
    });
});

export const warehousePlanList = ((params) => {
    return request({
        url: '/oms/pmWarehousePlan/list',
        data: params,
        method: 'POST'
    });
});

export const warehousePlanItemList = ((params) => {
    return request({
        url: '/oms/pmWarehousePlan/planItemList',
        data: params,
        method: 'POST'
    });
});


export const addWarehouseStock = ((params) => {
    return request({
        url: '/oms/pmWarehouseStock/add',
        data: params,
        method: 'POST'
    });
});

export const updateWarehouseStock = ((params) => {
    return request({
        url: '/oms/pmWarehouseStock/update',
        data: params,
        method: 'POST'
    });
});

export const WarehouseStockLog = ((params) => {
    return request({
        url: '/oms/pmWarehouseStock/log',
        data: params,
        method: 'POST'
    });
});

export const WarehouseStockLock = ((params) => {
    return request({
        url: '/oms/pmWarehouseStock/lock',
        data: params,
        method: 'POST'
    });
});


export const ToUpdateWarehouseStock = ((stockId) => {
    return request({
        url: '/oms/pmWarehouseStock/pmWarehouseStock_update/' + stockId,
        method: 'GET'
    });
});

export const ToDelWarehouseStock = ((params) => {
    return request({
        url: '/oms/pmWarehouseStock/del',
        data: params,
        method: 'POST'
    });
});

export const updateSeaWarehouseStock = ((stockId) => {
    return request({
        url: '/oms/pmWarehouseStock/updateSync/'+ stockId,
        //data: params,
        method: 'GET'
    });
});

export const soOrderToAbnormal = ((params) => {
    return request({
        url: '/oms/soItem/toAbnormal/',
        data: params,
        method: 'POST'
    });
});

export const soOrderUpdateAbnormal = ((params) => {
    return request({
        url: '/oms/soItem/updateAbnormal/',
        data: params,
        method: 'POST'
    });
});

export const createStockPlan = ((params) => {
    return request({
        url: '/oms/pmWarehouseStock/stockPlan',
        data: params,
        method: 'POST'
    });
});

export const getWarehouseStockDetail = ((id) => {
    return request({
        url: '/oms/pmWarehouseStock/detail/' + id,
        method: 'GET'
    });
});

export const brandList = ((params) => {
    return request({
        url: '/oms/brand/list',
        data: params,
        method: 'POST'
    });
});

export const addBrand = ((params) => {
    return request({
        url: '/oms/brand/add',
        data: params,
        method: 'POST'
    });
});

export const updateBrand = ((params) => {
    return request({
        url: '/oms/brand/update',
        data: params,
        method: 'POST'
    });
});

export const deleteBrand = ((params) => {
    return request({
        url: '/oms/brand/delete',
        data: params,
        method: 'POST'
    });
});

export const merchantList = ((params) => {
    return request({
        url: '/oms/merchant/list',
        data: params,
        method: 'POST'
    });
});
export const addMerchant = ((params) => {
    return request({
        url: '/oms/merchant/add',
        data: params,
        method: 'POST'
    });
});
export const updateMerchant = ((params) => {
    return request({
        url: '/oms/merchant/update',
        data: params,
        method: 'POST'
    });
});
export const deleteMerchant = ((params) => {
    return request({
        url: '/oms/merchant/delete',
        data: params,
        method: 'POST'
    });
});

export const deleteMerchantList = ((params) => {
        return request({
            url: '/oms/merchant/deleteList',
            data: params,
            method: 'POST'
        });
});

export const productsearchList = ((params) => {
    return request({
        url: '/oms/mdProduct/search',
        data: params,
        method: 'POST'
    });
});

export const finance_after_edit = ((params) => {
    return request({
        url: '/oms/ecpMonitoring/editinit',
        data: params,
        method: 'POST'
    });
});

export const productList = ((params) => {
    return request({
        url: '/oms/mdProduct/list',
        data: params,
        method: 'POST'
    });
});

export const productEditInit = ((params) => {
    return request({
        url: '/oms/mdProduct/mdProduct_add',
        data: params,
        method: 'POST'
    });
});

export const addProduct = ((params) => {
    return request({
        url: '/oms/mdProduct/add',
        data: params,
        method: 'POST'
    });
});

export const updateProduct = ((params) => {
    return request({
        url: '/oms/mdProduct/update',
        data: params,
        method: 'POST'
    });
});

export const updateEcpProduct = ((params) => {
    return request({
        url: '/oms/mdProduct/ecpUpdate',
        data: params,
        method: 'POST'
    });
});


export const deleteProductList = ((params) => {
    return request({
        url: '/oms/mdProduct/delete',
        data: params,
        method: 'POST'
    });
});

export const productDetail = ((mdProductId) => {
    return request({
        url: '/oms/mdProduct/detail/' + mdProductId,
        method: 'GET'
    });
});

export const deleteProductById = ((id) => {
    return request({
        url: '/oms/mdProduct/deleteId/'+id,
        method: 'GET'
    });
});

export const ecpProductDetail = ((mdProductId) => {
    return request({
        url: '/oms/mdProduct/ecpProductDetail/' + mdProductId,
        method: 'GET'
    });
});

export const downImportResult = ((params) => {
    return request({
        url: '/oms/tempSo/downImportResult',
        data: params,
        method: 'POST'
    });
});


export const importDataCommit = ((params) => {
    return request({
        url: '/oms/tempSo/importDataCommit',
        data: params,
        method: 'POST'
    });
});


export const importOrderDataCommit = ((params) => {
    return request({
        url: '/oms/ecpMonitoring/importOrderDataCommit',
        data: params,
        method: 'POST'
    });
});


export const importOrderData = ((params) => {
    return request({
        url: '/oms/ecpMonitoring/importOrderData',
        data: params,
        method: 'POST'
    });
});



export const downImportRefund = ((params) => {
    return request({
        url: '/oms/refundOrder/downImportRefund',
        data: params,
        method: 'POST'
    });
});

export const RefundSaveAdd = ((params) => {
    return request({
        url: '/oms/refundOrder/saveadd',
        data: params,
        method: 'POST'
    });
});

export const RefundFinanceSaveAdd = ((params) => {
    return request({
        url: '/oms/ecpMonitoring/saveadd',
        data: params,
        method: 'POST'
    });
});

export const importRefundCommit = ((params) => {
    return request({
        url: '/oms/refundOrder/importRefundCommit',
        data: params,
        method: 'POST'
    });
});


export const importRefundOrderCommit = ((params) => {
    return request({
        url: '/oms/ecpMonitoring/importRefundOrderCommit',
        data: params,
        method: 'POST'
    });
});

export const importRefund = ((params) => {
    return request({
        url: '/oms/refundOrder/importRefund',
        data: params,
        method: 'POST'
    });
});

export const ecpImportRefund = ((params) => {
    return request({
        url: '/oms/ecpMonitoring/ecpImportRefund',
        data: params,
        method: 'POST'
    });
});


export const proExcelIn = ((params) => {
    return request({
        url: '/oms/proExcel/in',
        data: params,
        method: 'POST'
    });
});

export const proDuctExcelIn = ((params) => {
    return request({
        url: '/oms/proExcel/proIn',
        data: params,
        method: 'POST'
    });
});

export const importRefundList = ((params) => {
    return request({
        url: '/oms/refundOrder/importList',
        data: params,
        method: 'POST'
    });
});

export const importPushEcpOrder = ((params) => {
    return request({
        url: '/oms/ecp/pushOrder',
        data: params,
        method: 'POST'
    });
});

export const importRefundPushEcpOrder = ((params) => {
    return request({
        url: '/oms/ecp/pushRefundOrder',
        data: params,
        method: 'POST'
    });
});


export const tempSoimportData = ((params) => {
    return request({
        url: '/oms/tempSo/importData',
        data: params,
        method: 'POST'
    });
});


export const tempSoImportList = ((params) => {
    return request({
        url: '/oms/tempSo/importOrderList',
        data: params,
        method: 'POST'
    });
});


export const tempSoList = ((params) => {
    return request({
        url: '/oms/tempSo/list',
        data: params,
        method: 'POST'
    });
});

export const tempSoInit = ((params) => {
    return request({
        url: '/oms/tempSo/init',
        data: params,
        method: 'POST'
    });
});

export const tempSoExport = ((params) => {
    return request({
        url: '/oms/tempSo/exportPlarformOrder',
        data: params,
        method: 'POST'
    });
});

export const tempSoGenerate = ((params) => {
    return request({
        url: '/oms/tempSo/generateOrderManual',
        data: params,
        method: 'POST'
    });
});

export const tempSoPullingOrder = ((params) => {
    return request({
        url: '/oms/tempSo/catchedOrderManual',
        data: params,
        method: 'POST'
    });
});

export const soOrderList = ((params) => {
    return request({
        url: '/oms/soOrder/list',
        data: params,
        method: 'POST'
    });
});

export const soOrderInit = ((virtualType) => {
    return request({
        url: '/oms/soOrder/init/'+ virtualType,
        // data: params,
        method: 'POST'
    });
});

export const warehouseStockInit = ((params) => {
    return request({
        url: '/oms/pmWarehouseStock/init',
        data: params,
        method: 'POST'
    });
});

export const mlSaleInit = ((params) => {
    return request({
        url: '/oms/ml/init',
        data: params,
        method: 'POST'
    });
});

export const mlSaleList = ((params) => {
    return request({
        url: '/oms/ml/list',
        data: params,
        method: 'POST'
    });
});

export const mlSaleSub = ((params) => {
    return request({
        url: '/oms/ml/sub',
        data: params,
        method: 'POST'
    });
});

export const mlSaleEntIn = ((params) => {
    return request({
        url: '/oms/ml/mlSaleEntIn',
        data: params,
        method: 'POST'
    });
});

export const soOrderExportVirtualOrder = ((params) => {
    return request({
        url: '/oms/soOrder/exportVirtualOrder',
        data: params,
        method: 'POST'
    });
});

export const soOrderExportTrueOut = ((params) => {
    return request({
        url: '/oms/soOrder/excelTrueOut',
        data: params,
        method: 'POST'
    });
});

export const soOrderPassStatus = ((params) => {
    return request({
        url: '/oms/soOrder/passStatus',
        data: params,
        method: 'POST'
    });
});

export const tempSoChangeBill = ((params) => {
    return request({
        url: '/oms/tempSo/changeBill',
        data: params,
        method: 'POST'
    });
});


export const soOrderNotRealPassStatus = ((params) => {
    return request({
        url: '/oms/soOrder/passNotRealStatus',
        data: params,
        method: 'POST'
    });
});


export const NewPassStatus = ((params) => {
    return request({
        url: '/oms/soOrder/NewPassStatus',
        data: params,
        method: 'POST'
    });
});

export const soOrderPassStatusPay = ((params) => {
    return request({
        url: '/oms/soOrder/passStatusPay',
        data: params,
        method: 'POST'
    });
});

export const soOrderCancelOrder = ((params) => {
    return request({
        url: '/oms/soOrder/cancelOrder',
        data: params,
        method: 'POST'
    });
});

export const soOrderToUnusualOrder = ((params) => {
    return request({
        url: '/oms/soOrder/toUnusualOrder',
        data: params,
        method: 'POST'
    });
});

export const soOrderUnusualOrder = ((params) => {
    return request({
        url: '/oms/soOrder/unusualOrder',
        data: params,
        method: 'POST'
    });
});

export const soOrderRemark = ((params) => {
    return request({
        url: '/oms/soOrder/updateRemark',
        data: params,
        method: 'POST'
    });
});
export const soOrderUserUpdateInit = ((soOrderId) => {
    return request({
        url: '/oms/soOrder/soOrderUserUpdate/' + soOrderId,
        method: 'POST'
    });
});

export const soOrderCarryLogic = ((soOrderId) => {
    return request({
        url: '/oms/soOrder/carryLogic/' + soOrderId,
        method: 'POST'
    });
});

export const soOrderUserUpdate = ((params) => {
    return request({
        url: '/oms/soOrder/addSoOrderUserUpdate',
        data: params,
        method: 'POST'
    });
});

export const soOrderUpdateLogic = ((params) => {
    return request({
        url: '/oms/soOrder/updateLogic',
        data: params,
        method: 'POST'
    });
});

export const soOperateLogList = ((params) => {
    return request({
        url: '/oms/soOperateLog/list',
        data: params,
        method: 'POST'
    });
});

export const tempSoOperateLog = ((params) => {
    return request({
        url: '/oms/tempSoOperateLog/list',
        data: params,
        method: 'POST'
    });
});

export const mdskulog = ((params) => {
    return request({
        url: '/oms/mdSku/log',
        data: params,
        method: 'POST'
    });
});

export const mdProductLog = ((params) => {
    return request({
        url: '/oms/mdProduct/log',
        data: params,
        method: 'POST'
    });
});

export const mdComboProductLog = ((params) => {
    return request({
        url: '/oms/mdComboProduct/log',
        data: params,
        method: 'POST'
    });
});


export const refundOrderLog = ((params) => {
    return request({
        url: '/oms/refundOrder/logList',
        data: params,
        method: 'POST'
    });
});

export const tempSoDetail = ((soOrderId) => {
    return request({
        url: '/oms/tempSo/tempSoDetail/' + soOrderId,
        method: 'POST'
    });
});


export const tempSoItemList = ((params) => {
    return request({
        url: '/oms/tempSoItem/list',
        data: params,
        method: 'POST'
    });
});

export const soOrderDetail = ((soOrderId) => {
    return request({
        url: '/oms/soOrder/soOrderDetail/' + soOrderId,
        method: 'POST'
    });
});

export const soOrderLogic = ((logicNo) => {
    return request({
        url: '/oms/soOrder/logic/' + logicNo,
        method: 'POST'
    });
});



export const soOrderItemList = ((params) => {
    return request({
        url: '/oms/soItem/list',
        data: params,
        method: 'POST'
    });
});

export const ecpSoItemSyc = ((soItemId) => {
    return request({
        url: '/oms/soItem/ecpItemUpdate/' + soItemId,
        method: 'POST'
    });
});

export const ecpProductHisList = ((params) => {
    return request({
        url: '/oms/mdProductEcpHis/list/',
        data: params,
        method: 'POST'
    });
});

export const soOrderCarryRemark = ((soOrderId) => {
    return request({
        url: '/oms/soOrder/carryRemark/' + soOrderId,
        method: 'POST'
    });
});

export const soOrderCarryYouZanRemark = ((soOrderId) => {
    return request({
        url: '/oms/soOrder/carryYouZanRemark/' + soOrderId,
        method: 'POST'
    });
});


export const soOrderUpdateCarry = ((params) => {
    return request({
        url: '/oms/soOrder/updateCarry',
        data: params,
        method: 'POST'
    });
});

export const soOrderUpdateYouZanCarry = ((params) => {
    return request({
        url: '/oms/soOrder/updateYouZanCarry',
        data: params,
        method: 'POST'
    });
});

export const grfHeaderInit = (() => {
    return request({
        url: '/oms/grfHeader/init',
        method: 'GET'
    });
});

export const grfHeaderList = ((params) => {
    return request({
        url: '/oms/grfHeader/list',
        data: params,
        method: 'POST'
    });
});

export const grfHeaderDetail = ((grfHeaderId) => {
    return request({
        url: '/oms/grfHeader/detail/' + grfHeaderId,
        method: 'POST'
    });
});

export const refundOrderInit = (() => {
    return request({
        url: '/oms/refundOrder/init',
        method: 'GET'
    });
});

export const refundOrderList = ((params) => {
    return request({
        url: '/oms/refundOrder/list',
        data: params,
        method: 'POST'
    });
});

export const tempSOToAbnormal = ((params) => {
    return request({
        url: '/oms/tempSo/toAbnormal/' + params.tempSoId,
        data: params,
        method: 'POST'
    });
});

export const tempSOToHandleAbnormalGoods = ((params) => {
    return request({
        url: '/oms/tempSo/handleAbnormalGoods',
        data: params,
        method: 'POST'
    });
});

export const tempSOUpdatePayOrderNo= ((params) => {
    return request({
        url: '/oms/tempSo/updateInfo',
        data: params,
        method: 'POST'
    });
});

export const tempSOToNormal= ((params) => {
    return request({
        url: '/oms/tempSo/toNormal',
        data: params,
        method: 'POST'
    });
});

export const tempSOToNormalList= ((params) => {
    return request({
        url: '/oms/tempSo/toNormalList',
        data: params,
        method: 'POST'
    });
});

export const tempBatchCancelList= ((params) => {
    return request({
        url: '/oms/tempSo/toBatchCancelList',
        data: params,
        method: 'POST'
    });
});


export const waitOrderDelete= ((params) => {
    return request({
        url: '/oms/tempSo/deleteWaitOrder',
        data: params,
        method: 'POST'
    });
});
export const tempSOVerifyList= ((params) => {
    return request({
        // url: '/oms/tempSo/tempSOVerifyList',
        url: '/oms/tempSo/batchToNormal',
        data: params,
        method: 'POST'
    });
});

export const mdComboProductList = ((params) => {
    return request({
        url: '/oms/mdComboProduct/list',
        data: params,
        method: 'POST'
    });
});

export const addMdComboProduct = ((params) => {
    return request({
        url: '/oms/mdComboProduct/add',
        data: params,
        method: 'POST'
    });
});

export const addDetailMdComboProduct = ((params) => {
    return request({
        url: '/oms/mdComboProduct/addDetail',
        data: params,
        method: 'POST'
    });
});


export const mdComboProductDetail = ((productId) => {
    return request({
        url: '/oms/mdComboProduct/detail/' + productId,
        method: 'GET'
    });
});

export const updateMdComboProduct = ((params) => {
    return request({
        url: '/oms/mdComboProduct/update',
        data: params,
        method: 'POST'
    });
});

export const deleteMdComboProduct = ((params) => {
    return request({
        url: '/oms/mdComboProduct/delete',
        data: params,
        method: 'POST'
    });
});
export const passOrderShuangXin = ((params) => {
    return request({
        url: '/oms/soOrder/passOrderShuangxin/',
        data: params,
        method: 'POST'
    });
});

export const refoundDownloadExport = ((params) => {
    return request({
        url: '/oms/refundOrder/download',
        data: params,
        method: 'POST'
    });
});

export const grfDownloadExport = ((params) => {
    return request({
        url: '/oms/grfHeader/download',
        data: params,
        method: 'POST'
    });
});

export const grfItemList = ((params) => {
    return request({
        url: '/oms/grfItem/selectListById',
        data: params,
        method: 'POST'
    });
});

export const refoundDetail = ((refundOrderId) => {
    return request({
        url: '/oms/refundOrder/detail/'+ refundOrderId,
        method: 'POST'
    });
});

export const salesAccountOrderList = ((params) => {
    return request({
        url: '/oms/report/salesAccountOrder/list',
        data: params,
        method: 'POST'
    });
});

export const salesAccountOrderInit = ((params) => {
    return request({
        url: '/oms/report/salesAccountOrder/init',
        data: params,
        method: 'POST'
    });
});

export const salesAccountOrderDownloadExport = ((params) => {
    return request({
        url: '/oms/report/salesAccountOrder/exportSalesAcountOrder',
        data: params,
        method: 'POST'
    });
});


export const taxReportDelete = ((params) => {
    return request({
        url: '/oms/report/taxReportDelete',
        data: params,
        method: 'POST'
    });
});

export const saveTaxExport = ((params) => {
    return request({
        url: '/oms/report/saveTaxExport',
        data: params,
        method: 'POST'
    });
});

export const taxReportInit = ((params) => {
    return request({
        url: '/oms/report/taxReportInit',
        data: params,
        method: 'POST'
    });
});

export const supplierInit = ((params) => {
    return request({
        url: '/oms/mdSupplier/list',
        data: params,
        method: 'POST'
    });
});

export const skuList = ((params) => {
    return request({
        url: '/oms/mdSku/list',
        data: params,
        method: 'POST'
    });
});

export const skuEditInit = ((params) => {
    return request({
        url: '/oms/mdSku/mdSku_add',
        data: params,
        method: 'POST'
    });
});

export const addSku = ((params) => {
    return request({
        url: '/oms/mdSku/add',
        data: params,
        method: 'POST'
    });
});

export const updateSku = ((params) => {
    return request({
        url: '/oms/mdSku/update',
        data: params,
        method: 'POST'
    });
});

export const skuDetail = ((skuId) => {
    return request({
        url: '/oms/mdSku/detail/' + skuId,
        method: 'GET'
    });
});

export const orderInterfaceLogList = ((params) => {7
    return request({
        url: '/oms/interfaceLog/init',
        data: params,
        method: 'POST'
    });
});

export const interfaceLogRemark = ((logId) => {
    return request({
        url: '/oms/interfaceLog/interfaceLogRemark/' + logId,
        method: 'POST'
    });
});

export const ecpTaskList = ((params) => {
    return request({
        url: '/oms/ecpTask/init',
        data: params,
        method: 'POST'
    });
});

export const ecpMonitoringInit = ((params) => {
    return request({
        url: '/oms/ecpMonitoring/init',
        data: params,
        method: 'POST'
    });
});

export const ecpPushPojo = ((params) => {
    return request({
        url: '/oms/ecpMonitoring/pushPojo',
        data: params,
        method: 'POST'
    });
});

export const pushListPojo = ((params) => {
    return request({
        url: '/oms/ecpMonitoring/pushListPojo',
        data: params,
        method: 'POST'
    });
});


export const pushListPojoState = ((params) => {
    return request({
        url: '/oms/ecpMonitoring/pushListPojoState',
        data: params,
        method: 'POST'
    });
});

export const cleanOrderPush = ((params) => {
    return request({
        url: '/oms/ecpMonitoring/cleanOrderPush',
        data: params,
        method: 'POST'
    });
});

export const ecpCleanFinanceAccount = ((params) => {
    return request({
        url: '/oms/ecpMonitoring/cleanFinanceAccount',
        data: params,
        method: 'POST'
    });
});

export const ecpMonitoringLog = ((params) => {
    return request({
        url: '/oms/ecpMonitoring/getLogMessage',
        data: params,
        method: 'POST'
    });
});

export const ecpMonitoringList = ((params) => {
    return request({
        url: '/oms/ecpMonitoring/list',
        data: params,
        method: 'POST'
    });
});

export const pushEcpPojo = ((params) => {
    return request({
        url: '/oms/ecpMonitoring/pushEcpList',
        data: params,
        method: 'POST'
    });
});

export const heavyPush = ((row) => {
    return request({
        url: '/oms/heavyPush/init',
        data: row,
        method: 'POST'
    });
});

export const batch = ((params) => {
    return request({
        url: '/oms/heavyPush/batch',
        data: params,
        method: 'POST'
    });
});


export const getPlatformById = ((id) => {
    return request({
        url: '/oms/platform/find/' + id,
        method: 'GET'
    });
});

export const addPlatform = ((params) => {
    return request({
        url: '/oms/platform/add',
        data: params,
        method: 'POST'
    });
});

export const updatePlatform = ((params) => {
    return request({
        url: '/oms/platform/update',
        data: params,
        method: 'POST'
    });
});

export const platformList = ((params) => {
    return request({
        url: '/oms/platform/list',
        data: params,
        method: 'POST'
    });
});

export const deletePlatform = ((params) => {
    return request({
        url: '/oms/platform/delete',
        data: params,
        method: 'POST'
    });
});


export const batchStockAddInit = ((params) => {
    return request({
        url: '/oms/batchStock/addInit',
        data: params,
        method: 'POST'
    });
});


export const rebateInit = ((params) => {
    return request({
        url: '/oms/batchStock/rebateInit',
        data: params,
        method: 'POST'
    });
});

export const mlstore = ((params) => {
    return request({
        url: '/oms/mlstore/list',
        data: params,
        method: 'POST'
    });
});

export const mlterminal = ((params) => {
    return request({
        url: '/oms/mlterminal/list',
        data: params,
        method: 'POST'
    });
});

export const mlreceiptveriflog = ((params) => {
    return request({
        url: '/oms/mlreceiptrec/veriflist',
        data: params,
        method: 'POST'
    });
});

export const mlrebaterule = ((params) => {
    return request({
        url: '/oms/mlrebaterule/list',
        data: params,
        method: 'POST'
    });
});

export const mlrebateruledelete = ((id) => {
    return request({
        url: '/oms/mlrebaterule/delete?id=' + id,
        method: 'GET'
    });
});

export const mlrebaterulegetrow = ((id) => {
    return request({
        url: '/oms/mlrebaterule/getRow?id=' + id,
        method: 'GET'
    });
});

export const mlrebateruleeditsave = ((params) => {
    return request({
        url: '/oms/mlrebaterule/editSave',
        data: params,
        method: 'POST'
    });
});

export const mlrebateruleaddsave = ((params) => {
    return request({
        url: '/oms/mlrebaterule/addSave',
        data: params,
        method: 'POST'
    });
});

export const batchStockAdd = ((params) => {
    return request({
        url: '/oms/batchStock/add',
        data: params,
        method: 'POST'
    });

});


export const mlreceiptreclist = ((params) => {
    return request({
        url: '/oms/mlreceiptrec/list',
        data: params,
        method: 'POST'
    });

});

export const batchWarehouseStockInit = ((params) => {
    return request({
        url: '/oms/batchStock/batchWarehouseStockInit',
        data: params,
        method: 'POST'
    });

});

export const batchWarehouseStockList = ((params) => {
    return request({
        url: '/oms/batchStock/batchWarehouseStockList',
        data: params,
        method: 'POST'
    });
});

export const pmWarehouseStockList = ((params) => {
    return request({
        url: '/oms/batchStock/pmWarehouseStockList',
        data: params,
        method: 'POST'
    });
});

export const mlreceiptverifexport = ((params) => {
    return request({
        url: '/oms/mlreceiptrec/verifexport',
        data: params,
        method: 'POST'
    });
});


export const mlreceipt_init = ((params) => {
    return request({
        url: '/oms/mlreceiptrec/init',
        data: params,
        method: 'POST'
    });
});


export const batchStockDetail = ((batchCode) => {
    return request({
        url: '/oms/batchStock/batchStockDetail/' + batchCode,
        method: 'POST'
    });
});

export const batchStockUpd = ((params) => {
    return request({
        url: '/oms/batchStock/batchStockUpd',
        data: params,
        method: 'POST'
    });
});

export const batchStockDel = ((id) => {
    return request({
        url: '/oms/batchStock/batchStockDel/' + id,
        method: 'POST'
    });
});


export const batchStockAddPm = ((params) => {
    return request({
        url: '/oms/batchStock/addPm',
        data: params,
        method: 'POST'
    });
});

export const batchFlowList = ((params) => {
    return request({
        url: '/oms/batchStock/batchFlowList',
        data: params,
        method: 'POST'
    });
});

export const mlveriforderexport = ((params) => {
    return request({
        url: '/oms/mlveriforder/export',
        data: params,
        method: 'POST'
    });
});


export const focusDetail = ((batchCode) => {
    return request({
        url: '/oms/batchStock/focusDetail/' + batchCode,
        method: 'POST'
    });
});

export const focusSubmit = ((params) => {
    return request({
        url: '/oms/batchStock/focusSubmit',
        data: params,
        method: 'POST'
    });
});

export const accountDisList = ((params) => {
    return request({
        url: '/oms/batchStock/accountDisList',
        data: params,
        method: 'POST'
    });
});

export const transferErrorOrder = ((params) => {
    return request({
        url: '/oms/tempSo/transferErrorOrder',
        data: params,
        method: 'POST'
    });
});

export const ecpSaveRemakes = ((params) => {
    return request({
        url: '/oms/ecpMonitoring/ecpSaveRemakes',
        data: params,
        method: 'POST'
    });
});

export const ecpUpdateCombinedCode = ((params) => {
    return request({
        url: '/oms/ecpMonitoring/ecpUpdateCombinedCode',
        data: params,
        method: 'POST'
    });
});

export const mdEcpTransform = ((params) => {
    return request({
        url: '/oms/mdEcpTransform/list',
        data: params,
        method: 'POST'
    });
});

export const mdEcpTransformDelete = ((params) => {
    return request({
        url: '/oms/mdEcpTransform/delete',
        data: params,
        method: 'POST'
    });
});

export const mdEcpTransformDeleteSize = ((params) => {
    return request({
        url: '/oms/mdEcpTransform/deleteSize',
        data: params,
        method: 'POST'
    });
});

export const ecpDerive = ((params) => {
    return request({
        url: '/oms/ecpMonitoring/ecpDerive',
        data: params,
        method: 'POST'
    });
});

export const ecprefundOrderId = ((id) => {
    return request({
        url: '/oms/ecpMonitoring/refundOrder/'+id,
        method: 'POST'
    });
});

export const makeUpBill = ((params) => {
    return request({
        url: '/oms/tempSo/makeUpBill',
        data: params,
        method: 'POST'
    });
});

export const speciaAddressInit = ((params) => {
        return request({
            url: '/oms/speciaAddress/init',
            data: params,
            method: 'POST'
        });
});

export const deletedBrandList = ((params) => {
    return request({
        url: '/oms/brand/deleteList',
        data: params,
        method: 'POST'
    });
});

export const brandDetail = ((id) => {
    return request({
        url: '/oms/brand/detail/'+id,

        method: 'POST'
    });
});


export const updateAddress = ((id) => {
    return request({
        url: '/oms/mdRegion/detail/'+id,

        method: 'POST'
    });
});

export const updateAddressId = ((params) => {
    return request({
        url: '/oms/mdRegion/update',
        data: params,
        method: 'POST'
    });
});

export const addAddress = ((params) => {
    return request({
        url: '/oms/mdRegion/add',
        data: params,
        method: 'POST'
    });
});

export const getAddressType = ((params) => {
    return request({
        url: '/oms/mdRegion/getAddressType',
        data: params,
        method: 'POST'
    });
});
export const deleteAddress = ((params) => {
    return request({
        url: '/oms/mdRegion/update',
        data: params,
        method: 'POST'
    });
});
export const articleDel = ((params) => {
        return request({
            url: '/oms/article/del',
            data: params,
            method: 'POST'
        });
});




// WEBPACK FOOTER //
// ./src/api/api.js